export default function($) {
  $(document).ready(function(){
    $('.js-slider--exhibitors').bxSlider({
      minSlides: 2,
      maxSlides: 5,
      moveSlides: 2,
      slideWidth: 206,
      slideMargin: 24,
      captions: true,
      pager: false,
      speed: 650,
      easing: "ease-in-out",
      auto: true,
      pause: 2000,
      autoDelay: 1000,
    });
  });
}
